import { useSelector } from 'react-redux';
import { useIataCode } from '../../../../hooks';
import { shouldSkipPassengers } from '@shared/lib/passengers';
import { getPassengersIds } from '../model/passengers/selectors';
export const useSkipPassengers = () => {
    const iataCode = useIataCode();
    const passengersIds = useSelector(getPassengersIds);
    return shouldSkipPassengers(passengersIds.length, iataCode);
};
